<template>
  <b-modal :active="value" has-modal-card @close="close()">
    <form v-if="data" action="">
      <div class="modal-card" style="width: 860px">
        <!-- ヘッダ -->
        <header class="modal-card-head">
          <p
            class="modal-card-title"
            style="color: whitesmoke; text-align: left"
          >
            <span v-if="data.patientSupportHistoryId">対応記録参照</span>
            <span v-else>対応記録入力</span>
          </p>
        </header>

        <!-- セクション -->
        <section class="modal-card-body" style="width: 100%; text-align: left">
          <!-- General task対応 -->
          <div v-if="showGeneralTaskArea" class="box field is-floating-label" style="margin-bottom: 30px">
            <label class="label">患者管理チーム対応</label>

            <div v-if="showGeneralTaskButtonArea" class="columns">
              <div class="column is-half">
                <b-button
                  v-if="showRemandGeneralTaskButton"
                  class="button"
                  type="is-primary"
                  @click="remandGeneralTask()"
                >
                  差戻
                </b-button>
              </div>
              <div class="column is-half">
                <b-button
                  v-if="showCompletedGeneralTaskButton"
                  class="button"
                  type="is-primary"
                  style="float: right; margin-left: 10px;"
                  @click="completedGeneralTask()"
                >
                  対応完了
                </b-button>
                <b-button
                  v-if="showStartGeneralTaskButton"
                  class="button"
                  type="is-primary"
                  style="float: right"
                  @click="startGeneralTask()"
                >
                  対応開始
                </b-button>
              </div>
            </div>

            <div class="columns">
              <div class="column is-half">
                <b-field label="対応状況" labelPosition="on-border">
                  <b-input
                    v-model="data.gtAction.status.name"
                    name="patientName"
                    type="text"
                    readonly
                  ></b-input>
                </b-field>
              </div>
            </div>

            <div v-if="data.gtAction.startUserName" class="columns">
              <div class="column is-half">
                <b-field label="対応開始者" labelPosition="on-border">
                  <b-input
                    v-model="data.gtAction.startUserName"
                    name="startUserName"
                    type="text"
                    readonly
                  ></b-input>
                </b-field>
              </div>

              <div class="column is-half">
                <b-field label="対応開始日時" labelPosition="on-border">
                  <b-input
                    v-model="startDatetime"
                    name="startDatetime"
                    type="text"
                    readonly
                  ></b-input>
                </b-field>
              </div>
            </div>

            <div v-if="data.gtAction.completeUserName" class="columns">
              <div class="column is-half">
                <b-field label="対応完了者" labelPosition="on-border">
                  <b-input
                    v-model="data.gtAction.completeUserName"
                    name="completeUserName"
                    type="text"
                    readonly
                  ></b-input>
                </b-field>
              </div>

              <div class="column is-half">
                <b-field label="対応完了日時" labelPosition="on-border">
                  <b-input
                    v-model="completeDatetime"
                    name="completeDatetime"
                    type="text"
                    readonly
                  ></b-input>
                </b-field>
              </div>
            </div>

            <div v-if="data.gtAction.remandUserName" class="columns">
              <div class="column is-half">
                <b-field label="差戻者" labelPosition="on-border">
                  <b-input
                    v-model="data.gtAction.remandUserName"
                    name="remandUserName"
                    type="text"
                    readonly
                  ></b-input>
                </b-field>
              </div>

              <div class="column is-half">
                <b-field label="差戻日時" labelPosition="on-border">
                  <b-input
                    v-model="remandDatetime"
                    name="remandDatetime"
                    type="text"
                    readonly
                  ></b-input>
                </b-field>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column is-half">
              <b-field label="患者名" labelPosition="on-border">
                <b-input
                  v-model="data.patientName"
                  name="patientName"
                  type="text"
                  readonly
                ></b-input>
              </b-field>
            </div>

            <div class="column">
              <b-checkbox :disabled="!!data.patientSupportHistoryId" v-model="mail.isSend" name="isSend">
                担当者にメール
              </b-checkbox>
              <b-checkbox :disabled="!!data.patientSupportHistoryId" v-model="mail.isSendGt" name="isSendGt">
                患者管理チームにメール
              </b-checkbox>
            </div>
          </div>

          <div class="columns">
            <div class="column is-half">
              <b-field label="患者対応記入者" labelPosition="on-border">
                <b-input
                  v-model="data.entryStaffName"
                  :readonly="true"
                  name="entryStaffName"
                  style="width: 100%"
                ></b-input>
                <b-button
                  v-if="!data.patientSupportHistoryId"
                  style="float: right; bottom: 0"
                  class="button is-primary has-text-centered"
                  icon-left="account-switch"
                  native-type="button"
                  v-on:click="showStaffSelecter()"
                ></b-button>
                <staffChange-modal
                  v-model="isSupportStaffChangeActive"
                  :title="'患者対応記入者選択'"
                  :office-code="userInfo.officeCode"
                  :officeMasterList="referenceEnableOffices"
                  v-on:staff-change-event="selectStaff($event)"
                ></staffChange-modal>
              </b-field>
            </div>

            <div class="column">
              <b-field
                v-if="mail.isSend || mail.isSendGt"
                label="メール件名プレフィックス"
                labelPosition="on-border"
              >
                <b-select
                  v-if="!data.patientSupportHistoryId"
                  expanded
                  v-model="mail.subjectPrefixId"
                  name="subjectPrefix"
                >
                  <option
                    v-for="prefix in prefixes"
                    :key="prefix.id"
                    :value="prefix.id"
                  >
                    {{ prefix.name }}
                  </option>
                </b-select>
                <b-input
                  v-else
                  :value="prefixes.find((elem) => elem.id == mail.subjectPrefixId) ? prefixes.find((elem) => elem.id == mail.subjectPrefixId).name : ''"
                  name="subjectPrefix"
                  type="text"
                  readonly
                ></b-input>
              </b-field>
            </div>
          </div>

          <div class="columns">
            <div class="column is-one-fifth">
              <b-field
                label="受付日"
                labelPosition="on-border"
                :type="{ 'is-danger': errors.has('callDate') }"
                :message="errors.first('callDate')"
              >
                <b-datepicker
                  v-if="!data.patientSupportHistoryId"
                  name="callDate"
                  data-vv-as="受付日"
                  v-model="callDate"
                  placeholder="select a date.."
                  icon="calendar-today"
                  :month-names="monthNames"
                  :day-names="dayNames"
                  v-validate="'required'"
                  data-vv-validate-on="input"
                ></b-datepicker>
                <b-input
                  v-else
                  :value="callDateString"
                  name="callDate"
                  type="text"
                  readonly
                ></b-input>
              </b-field>
            </div>
            <div class="column is-one-fifth">
              <b-field
                label="受付時間"
                labelPosition="on-border"
                :type="{ 'is-danger': errors.has('callTime') }"
                :message="errors.first('callTime')"
              >
                <b-timepicker
                  v-if="!data.patientSupportHistoryId"
                  name="callTime"
                  data-vv-as="受付時間"
                  v-model="callTime"
                  placeholder="Type or select a date..."
                  icon="clock"
                  v-validate="'required'"
                  data-vv-validate-on="input"
                ></b-timepicker>
                <b-input
                  v-else
                  :value="callTimeString"
                  name="callTime"
                  type="text"
                  readonly
                ></b-input>
              </b-field>
            </div>
            <div class="column">
              <b-button
                v-if="!data.patientSupportHistoryId"
                class="button is-primary"
                type="button"
                @click="setDatetime()"
              >
                now
              </b-button>
            </div>
            <div class="column is-half">
              <!-- 担当者 -->
              <b-field
                v-if="mail.isSend"
                :label="$store.state.subSystem.staff.label"
                labelPosition="on-border"
                :type="{ 'is-danger': errors.has('staffName') }"
                :message="errors.first('staffName')"
                style="flex-wrap: wrap"
              >
                <div style="width: 100%; display: flex">
                  <b-input
                    v-model="mail.staffName"
                    :readonly="true"
                    name="staffName"
                    :data-vv-as="$store.state.subSystem.staff.label"
                    v-validate="'required'"
                    style="flex-grow: 1"
                  ></b-input>
                  <b-button
                    v-if="!data.patientSupportHistoryId"
                    style="float: right; bottom: 0"
                    class="button is-primary has-text-centered"
                    icon-left="account-switch"
                    native-type="button"
                    v-on:click="showInspectionStaffSelecter()"
                  ></b-button>
                </div>
                <staffChange-modal
                  v-model="isInspectionSupportStaffChangeActive"
                  :office-code="userInfo.StaffCode"
                  :officeMasterList="referenceEnableOffices"
                  v-on:staff-change-event="selectInspectionStaff($event)"
                ></staffChange-modal>
              </b-field>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <b-field
                label="医療機関"
                labelPosition="on-border"
                :type="{ 'is-danger': errors.has('hospital') }"
                :message="errors.first('hospital')"
              >
                <b-select
                  v-if="!data.patientSupportHistoryId"
                  expanded
                  v-model="data.hospital"
                  name="hospital"
                  data-vv-as="医療機関"
                  @input="inputHospital($event)"
                >
                  <option
                    v-for="hospital in hospitals"
                    :key="hospital.hospitalCode"
                    :value="hospital"
                  >
                    {{ hospital.hospitalName }}
                  </option>
                </b-select>
                <b-input
                  v-else
                  :value="data.hospitalName"
                  name="hospital"
                  type="text"
                  readonly
                ></b-input>
              </b-field>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <b-field
                label="カテゴリ"
                labelPosition="on-border"
                :type="{ 'is-danger': errors.has('category') }"
                :message="errors.first('category')"
              >
                <b-select
                  v-if="!data.patientSupportHistoryId"
                  expanded
                  v-model="data.categoryId"
                  name="category"
                  data-vv-as="カテゴリ"
                  v-validate="'required'"
                >
                  <option
                    v-for="category in categories"
                    :key="category.id"
                    :value="category.id"
                  >
                    {{ category.categoryName }}
                  </option>
                </b-select>
                <b-input
                  v-else
                  :value="categories.find((elem) => elem.id == data.categoryId) ? categories.find((elem) => elem.id == data.categoryId).categoryName : ''"
                  name="category"
                  type="text"
                  readonly
                ></b-input>
              </b-field>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <b-field v-if="!data.patientSupportHistoryId" label="例文テンプレート" labelPosition="on-border">
                <b-select
                  v-model="template"
                  expanded
                  name="template"
                  @change.native="addTemplate()"
                >
                  <option
                    v-for="template in templates"
                    :value="template"
                    :key="template.id"
                  >
                    {{ template.templateName }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <b-field
                label="対応内容"
                labelPosition="on-border"
                :type="{ 'is-danger': errors.has('contents') }"
                :message="errors.first('contents')"
              >
                <b-input
                  ref="contents"
                  v-model="data.contents"
                  name="contents"
                  type="textarea"
                  data-vv-as="対応内容"
                  v-validate="'required'"
                  maxlength="512"
                  :readonly="data.patientSupportHistoryId"
                ></b-input>
              </b-field>
            </div>
          </div>

          <!-- 機器一覧 -->
          <ul v-if="data.patientSupportHistoryId" style="margin-bottom: 15px;">
            <li v-for="product in data.productList" :key="product.serial">
              ・ {{ product.itemName + "(" + product.itemCode + ")" }}
            </li>
          </ul>

          <!-- 添付 -->
          <div class="columns">
            <div class="column">
              <file-chooser
                v-model="data.files"
                v-on:download-file="downloadFile($event)"
                :readonly="!!data.patientSupportHistoryId"
              ></file-chooser>
            </div>
          </div>
        </section>

        <!-- フッタ -->
        <footer class="modal-card-foot">
          <b-button
            v-if="!data.patientSupportHistoryId"
            class="button"
            type="button"
            @click="save()"
          >
            登録
          </b-button>
          <b-button class="button" type="button" @click="close()">
            閉じる
          </b-button>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
const dayjs = require('dayjs');

import FileChooser from "./common/FileChooser.vue";
import StaffChangeModalForm from "./common/StaffChooser.vue";
import * as datetime from "../utils/datetime";
import * as subSystemUtil from "../utils/subSystem";
import * as patientUtil from "../utils/patient";

export default {
  name: "AppSupport",
  props: {
    value: { type: Boolean, default: false },
    patient: { type: Object, default: null },
    supportHistory: { type: Object, default: null },
  },

  computed: {
    showGeneralTaskArea: function () {
      const showGeneralTaskArea = this.data.patientSupportHistoryId && this.data.mail && this.data.mail.isSendGt;
      return showGeneralTaskArea;
    },
    showGeneralTaskButtonArea: function () {
      let showGeneralTaskButton = false;
      if (this.userInfo.isGt) {
        switch (this.data.gtAction.status.code) {
          case patientUtil.GT_STATUS_MAP.actionRequired.code:
          case patientUtil.GT_STATUS_MAP.inProgress.code:
            showGeneralTaskButton = true;
            break;
        }
      }
      return showGeneralTaskButton;
    },
    showStartGeneralTaskButton: function () {
      let showStartGeneralTaskButton = false;
      switch (this.data.gtAction.status.code) {
        case patientUtil.GT_STATUS_MAP.actionRequired.code:
          showStartGeneralTaskButton = true;
          break;
      }
      return showStartGeneralTaskButton;
    },
    showCompletedGeneralTaskButton: function () {
      let showCompletedGeneralTaskButton = false;
      switch (this.data.gtAction.status.code) {
        case patientUtil.GT_STATUS_MAP.actionRequired.code:
        case patientUtil.GT_STATUS_MAP.inProgress.code:
          showCompletedGeneralTaskButton = true;
          break;
      }
      return showCompletedGeneralTaskButton;
    },
    showRemandGeneralTaskButton: function () {
      let showRemandGeneralTaskButton = false;
      switch (this.data.gtAction.status.code) {
        case patientUtil.GT_STATUS_MAP.actionRequired.code:
          showRemandGeneralTaskButton = true;
          break;
      }
      return showRemandGeneralTaskButton;
    },
    startDatetime: function () {
      const startDatetime = this.data.gtAction.startDatetime ? dayjs(this.data.gtAction.startDatetime).format("YYYY/MM/DD HH:mm") : null;
      return startDatetime;
    },
    completeDatetime: function () {
      const completeDatetime = this.data.gtAction.completeDatetime ? dayjs(this.data.gtAction.completeDatetime).format("YYYY/MM/DD HH:mm") : null;
      return completeDatetime;
    },
    remandDatetime: function () {
      const remandDatetime = this.data.gtAction.remandDatetime ? dayjs(this.data.gtAction.remandDatetime).format("YYYY/MM/DD HH:mm") : null;
      return remandDatetime;
    },
  },

  methods: {
    close: function () {
      this.$emit("input", false);
      return;
    },

    selectStaff: function (staffInfo) {
      this.data.entryStaffName = staffInfo.staffName;
      this.data.entryStaffCode = staffInfo.id;
      this.data.officeCode = staffInfo.newStaffoffice;
      this.data.officeName = staffInfo.newStaffofficeName;
      return;
    },

    selectInspectionStaff: function (staffInfo) {
      this.mail.staffCode = staffInfo.id;
      this.mail.staffName = staffInfo.staffName;
      return;
    },

    showStaffSelecter: function () {
      this.isSupportStaffChangeActive = true;
      return;
    },

    inputHospital: function (hospital) {
      if (!this.mail.staffName) {
        if (hospital.staffId) {
          this.mail.staffCode = hospital.staffId;
          this.mail.staffName = hospital.staffName;
        }
      }
      return;
    },

    showInspectionStaffSelecter: function () {
      this.isInspectionSupportStaffChangeActive = true;
      return;
    },

    addTemplate: function () {
      const addPos =
        this.$refs.contents.$el.getElementsByClassName("textarea")[0]
          .selectionStart;

      this.data.contents =
        this.data.contents.substring(0, addPos) +
        this.template.template +
        this.data.contents.substring(addPos);

      return;
    },

    save: async function () {
      // バリデーション
      const validateRes = await this.$validator.validateAll();
      if (!validateRes) {
        return;
      }

      const confiermRes = await this.showComfirmMessage(
        "登録後は編集できません。よろしいですか？"
      );

      // WebAPI呼び出し
      if (confiermRes) {
        if (this.data.files.length) {
          // ファイルオブジェクト除去
          let files = JSON.parse(JSON.stringify(this.data.files));
          for (const file of files) {
            delete file.file;
          }
          this.uploadFiles = files;

          // 添付ファイルアップロード
          let s3UploadData;
          try {
            s3UploadData = await this.multipleUpload(
              this.data.files,
              this.$store.state.subSystem,
              this.showErrorMessage,
            );
          } catch (err) {
            // エラーコールバックで処理済み
            return;
          }
          if (s3UploadData.identifier) {
            this.data.s3UploadData = s3UploadData;
          }
        }

        this.apiCall(
          this.setPatientSupportHistory,
          this.callWebApiSuccess,
          this.callWebApiError,
          this.$store.state.subSystem
        );
      }
    },

    // 登録,更新
    setPatientSupportHistory: function (client) {
      const dataString = JSON.stringify(this.data);
      const data = JSON.parse(dataString);
      data.files = this.uploadFiles;

      if (this.mail.isSend == true || this.mail.isSendGt == true) {
        data.mail = {
          isSendGt: this.mail.isSendGt,
          staffCode: this.mail.isSend ? this.mail.staffCode : null,
          staffName: this.mail.isSend ? this.mail.staffName : null,
          subjectPrefixId: this.mail.subjectPrefixId,
        };
      }

      data.hospitalCode = data.hospital.hospitalCode;
      delete data.hospital;
      data.entryStaffCode = data.entryStaffCode.toString();

      let apiRes;
      if (this.data.patientSupportHistoryId) {
        // 更新
        apiRes = client.apis.apiPatientSupport.setPatientSupportHistoryPUT({
          body: data,
        });
      } else {
        // 登録
        apiRes = client.apis.apiPatientSupport.setPatientSupportHistoryPOST({
          body: data,
        });
      }

      return apiRes;
    },

    // WebAPI成功
    callWebApiSuccess: function (result) {
      if (result.body.gtAction) this.$emit("update-gt-action", result.body.gtAction);
      this.showSuccess(result);
      this.$emit("update-support-history");
      this.close();
      return;
    },
    // WebAPIエラー
    callWebApiError: function (result) {
      this.showErrorMessage(result);
      return;
    },

    initData: function () {
      // 医療機関選択肢
      const omitHospital = {
        hospitalCode: null,
        hospitalName: "",
      };
      const hospitals = [];
      const hospitalCodes = [];
      for (const productDetail of this.patient.productDetail) {
        const hospitalCodeExist = hospitalCodes.includes(
          productDetail.hospitalCode
        );
        if (!hospitalCodeExist) {
          hospitalCodes.push(productDetail.hospitalCode);
          hospitals.push(productDetail);
        }
      }
      this.hospitals = hospitals;

      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      const officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
      const referenceEnableOffices = JSON.parse(
        sessionStorage.getItem("referenceEnableOffice")
      );

      let data;
      let callDate;
      let callDateString;
      let callTime;
      let callTimeString;
      if (this.supportHistory) {
        let office = officeMaster.find(
          (elem) => elem.officeName == this.supportHistory.salesOfficeName
        );
        if (this.supportHistory.callDate) {
          callDate = this.parseDate(this.supportHistory.callDate);
          callDateString = this.supportHistory.callDate;
        }
        if (this.supportHistory.callTime) {
          callTime = this.parseTime(this.supportHistory.callTime);
          callTimeString = this.supportHistory.callTime;
        }

        if (this.supportHistory.hospitalCode) {
          this.supportHistory.hospital = hospitals.find(
            (elem) => elem.hospitalCode == this.supportHistory.hospitalCode
          );

          if (!this.supportHistory.hospital) {
            this.getCustomerList();
          }
        } else {
          this.supportHistory.hospital = omitHospital;
        }

        data = this.supportHistory;
        data.officeCode = office.officeCode;
        data.officeName = this.supportHistory.salesOfficeName;

        // 対応内容からカテゴリ名除去
        data.contents = data.contents.substring(
          0,
          data.contents.indexOf(String.fromCharCode(16))
        );
      } else {
        let office = officeMaster.find(
          (elem) => elem.officeCode == userInfo.officeCode
        );
        data = {
          patientCode: this.patient.patientCode,
          patientName: this.patient.patientName,
          entryStaffCode: userInfo.id,
          entryStaffName: userInfo.fullName,
          officeCode: userInfo.officeCode,
          officeName: office.officeName,
          callDateString: null,
          callDate: null,
          callTimeString: null,
          callTime: null,
          hospital: hospitals.length == 1 ? hospitals[0] : omitHospital,
          categoryId: null,
          contents: "",
          files: [],
        };
      }

      hospitals.unshift(omitHospital);

      if (this.supportHistory && this.supportHistory.mail) {
        this.mail.isSend = this.supportHistory.mail.staffCode ? true : false;
        this.mail.staffName = this.supportHistory.mail.staffName;
        this.mail.staffCode = this.supportHistory.mail.staffCode;
        this.mail.subjectPrefixId = this.supportHistory.mail.subjectPrefixId;
        this.mail.isSendGt = this.supportHistory.mail.isSendGt;
      } else {
        this.mail.isSend = false;
        this.mail.isSendGt = false;

        if (this.hospitals.length == 1 && this.hospitals[0].staffId) {
          this.mail.staffCode = this.hospitals[0].staffId;
          this.mail.staffName = this.hospitals[0].staffName;
        } else {
          this.mail.staffCode = null;
          this.mail.staffName = null;
        }
      }

      this.data = data;
      this.callDate = callDate;
      this.callDateString = callDateString;
      this.callTime = callTime;
      this.callTimeString = callTimeString;
      this.userInfo = userInfo;
      this.referenceEnableOffices = referenceEnableOffices;
      this.template = null;

      // カテゴリ選択肢取得
      this.apiCall(
        this.getPatientSupportHistoryCategories,
        this.getPatientSupportHistoryCategoriesSuccess,
        this.showErrorMessage
      );

      // テンプレート選択肢取得
      this.apiCall(
        this.getPatientSupportHistoryTemplates,
        this.getPatientSupportHistoryTemplatesSuccess,
        this.showErrorMessage
      );

      // メール件名プレフィックス選択肢取得
      this.apiCall(
        this.getPatientSupportHistoryMailSubjectPrefixes,
        this.getPatientSupportHistoryMailSubjectPrefixesSuccess,
        this.showErrorMessage
      );

      return;
    },

    downloadFile: function (fileInfo) {
      this.fileInfo = fileInfo;
      this.downloadS3ApiCall(
        this.getPatientSupportFileGET,
        this.getPatientSupportFileGETError,
        subSystemUtil.SUB_SYSTEMS[fileInfo.subsystem]
      );
    },

    getPatientSupportFileGET: function (client) {
      const apiRes = client.apis.apiPatientSupport.getPatientSupportFileGET({
        id: this.fileInfo.id,
        patientCode: this.patient.patientCode,
      });
      return apiRes;
    },

    getPatientSupportFileGETError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },

    getPatientSupportHistoryTemplates: function (client) {
      const apiRes =
        client.apis.apiPatientSupport.getPatientSupportHistoryTemplatesGET({
          mode: "ref",
          officeCode: this.userInfo.officeCode,
        });
      return apiRes;
    },

    getPatientSupportHistoryTemplatesSuccess: function (result) {
      this.templates = result.obj;
      return;
    },

    getPatientSupportHistoryCategories: function (client) {
      const apiRes =
        client.apis.apiPatientSupport.getPatientSupportHistoryCategoriesGET();
      return apiRes;
    },

    getPatientSupportHistoryCategoriesSuccess: function (result) {
      if (this.data.patientSupportHistoryId) {
        this.categories = result.obj;
      } else {
        // システム向けカテゴリーを除外
        this.categories = result.obj.filter((elem) => elem.id < 2000000000);
      }
      return;
    },

    getPatientSupportHistoryMailSubjectPrefixes: function (client) {
      const apiRes =
        client.apis.apiPatientSupport.getPatientSupportHistoryMailSubjectPrefixesGET();
      return apiRes;
    },

    getPatientSupportHistoryMailSubjectPrefixesSuccess: function (result) {
      this.prefixes = result.obj;
      return;
    },

    setDatetime: function () {
      this.callDate = new Date();
      this.callTime = new Date();
    },

    startGeneralTask: function () {
      this.generalTaskStatus = patientUtil.GT_STATUS_MAP.inProgress;
      this.apiCall(
        this.setPatientSupportHistoryGtStatus,
        this.setPatientSupportHistoryGtStatusSuccess,
        this.callWebApiError,
        this.$store.state.subSystem
      );

      return;
    },

    completedGeneralTask: function () {
      this.generalTaskStatus = patientUtil.GT_STATUS_MAP.actionCompleted;
      this.apiCall(
        this.setPatientSupportHistoryGtStatus,
        this.setPatientSupportHistoryGtStatusSuccess,
        this.callWebApiError,
        this.$store.state.subSystem
      );

      return;
    },

    remandGeneralTask: function () {
      this.generalTaskStatus = patientUtil.GT_STATUS_MAP.remand;
      this.apiCall(
        this.setPatientSupportHistoryGtStatus,
        this.setPatientSupportHistoryGtStatusSuccess,
        this.callWebApiError,
        this.$store.state.subSystem
      );

      return;
    },

    setPatientSupportHistoryGtStatus: function (client) {
      const dataString = JSON.stringify(this.data);
      const data = JSON.parse(dataString);

      if (this.mail.isSend == true || this.mail.isSendGt == true) {
        data.mail = {
          isSendGt: this.mail.isSendGt,
          staffCode: Number(this.mail.staffCode),
          staffName: this.mail.staffName,
          subjectPrefixId: this.mail.subjectPrefixId,
        };
      }

      data.hospitalCode = data.hospital.hospitalCode;
      delete data.hospital;
      delete data.hospitalName;
      data.entryStaffCode = data.entryStaffCode.toString();

      delete data.gtAction;
      data.gtStatus = this.generalTaskStatus.code;

      let apiRes = client.apis.apiPatientSupport.setPatientSupportHistoryGtStatusPOST({
        body: data,
      });

      return apiRes;
    },

    setPatientSupportHistoryGtStatusSuccess: function (result) {
      switch (this.generalTaskStatus) {
        case patientUtil.GT_STATUS_MAP.inProgress:
          this.data.gtAction.startUserName = this.userInfo.fullName;
          this.data.gtAction.startDatetime = result.body.operationDatetime;
          break;

        case patientUtil.GT_STATUS_MAP.actionCompleted:
          this.data.gtAction.completeUserName = this.userInfo.fullName;
          this.data.gtAction.completeDatetime = result.body.operationDatetime;
          break;

        case patientUtil.GT_STATUS_MAP.remand:
          this.data.gtAction.remandUserName = this.userInfo.fullName;
          this.data.gtAction.remandDatetime = result.body.operationDatetime;
          break;
      }

      this.data.gtAction.status = this.generalTaskStatus;
      this.generalTaskStatus = null;
      
      if (result.body.gtAction) this.$emit("update-gt-action", result.body.gtAction);

      this.showSuccess(result);
      return;
    },

    getCustomerList: function () {
      this.apiCall(
        this.getCustomerListPOST,
        this.getCustomerListSuccess,
        this.callWebApiError
      );

      return;
    },

    getCustomerListPOST: function (client) {
      let apiRes = client.apis.apiMaster.getCustomerListPOST({
        body: {
          code: this.supportHistory.hospitalCode,
        },
      });

      return apiRes;
    },

    getCustomerListSuccess: function (result) {
      const hospitals = result.body;
      const hospital = hospitals.find((elem) => elem.code == this.supportHistory.hospitalCode);
      if (hospital) {
        this.supportHistory.hospital = {
          hospitalCode: hospital.code,
          hospitalName: hospital.name,
        };
      }

      return;
    },
  },

  created: function () {},

  mounted: function () {},

  data() {
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));

    return {
      data: null,
      callDate: null,
      callTime: null,
      mail: {
        isSend: false,
        isSendGt: false,
        staffName: null,
        staffCode: null,
        subjectPrefixId: 2,
      },
      isSupportStaffChangeActive: false,
      isInspectionSupportStaffChangeActive: false,
      categories: null,
      template: null,
      templates: null,
      userInfo: null,
      referenceEnableOffices: null,
      monthNames: datetime.MONTHS,
      dayNames: datetime.DAYS,
      fileInfo: null,
      hospitals: [],
      prefixes: null,
      uploadFiles: [],
      userInfo: userInfo,
    };
  },

  watch: {
    value: function () {
      if (this.value) {
        this.initData();
      }
      return;
    },

    callDate: function (value) {
      this.data.callDate = value ? this.formatDate2(value) : null;
      return;
    },

    callTime: function (value) {
      this.data.callTime = value ? this.formatTime(value) : null;
      return;
    },
  },

  filters: {},

  components: {
    "staffChange-modal": StaffChangeModalForm,
    "file-chooser": FileChooser,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AppSupport.vue